import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';
import * as Roles from './../constants/roles';
import { setError } from './index';

export const SET_USER = 'SET_USER';

const setUser = payload => ({ type: SET_USER, payload });

export const setUserById = payload => {
    return dispatch => {
        return db.ref(`${Constants.USERS}/${payload}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists()) {
                    var user = snapshot.val();
                    //console.log("getUser: " + JSON.stringify(user));
                    if(user.roles) {
                        var roles = user.roles;
                        if(roles.indexOf(Roles.ADMIN) > -1) {
                            dispatch(setUser(user));
                            dispatch(setError({ state: false, rason: ""}));
                        } else if(roles.indexOf(Roles.RESTO) > -1) {
                            if(user.restaurantsId && user.restaurantsId[0] !== "") {
                                //console.log("Resto id: " + user.restaurantsId[0]);
                                dispatch(setUser(user));
                                dispatch(setError({ state: false, rason: ""}));
                            } else {
                                //console.log("Resto is empty");
                                dispatch(setError({ state: true, rason: "RESTO_EMPTY"}));
                                dispatch(setUser(null));
                            }
                        } else {
                            dispatch(setError({ state: true, rason: "USER_NOT_AVAILABLE"}));
                            dispatch(setUser(null));
                        }
                    } else {
                        dispatch(setError({ state: true, rason: "USER_NOT_AVAILABLE"}));
                        dispatch(setUser(null));
                    }
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setError({ state: true, rason: "USER_NOT_AVAILABLE"}));
                    dispatch(setUser(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setError({ state: true, rason: "USER_NOT_FOUND"}));
                dispatch(setUser(null));
        });
    };
};